import { c as _c } from "react/compiler-runtime";
import { Content } from "@/types/squidex";
import { PropsWithClassName } from "@/types/ui";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@components/ui/avatar";
import { cn } from "@lib/utils";
import { proposalsTools } from "@features/proposals/proposals-tools";
import { ContributorBiographyContentData } from "@features/proposals/types/member";
interface MemberPhotoViewProps {
  biography?: {
    content?: Content<ContributorBiographyContentData>;
  };
  firstName?: string;
  lastName?: string;
  size?: "sm" | "md" | "lg" | "xl";
}
const photoDisplaySizePx = {
  sm: 48,
  md: 64,
  lg: 96,
  xl: 128
};

/**
 * Component for displaying activity member photo/avatar.
 * Extracts and displays a speaker photo from biography content.
 * Uses optimized image URL for Squidex-hosted biography photos and provides fallback with initials.
 */
export const MemberPhotoView = t0 => {
  const $ = _c(24);
  const {
    biography,
    firstName,
    lastName,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] !== biography?.content || $[1] !== size) {
    t2 = proposalsTools.activityMemberTools.extractBiographyImages(biography?.content, photoDisplaySizePx[size]);
    $[0] = biography?.content;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const photoUrls = t2;
  const photoUrl = photoUrls?.[0];
  let t3;
  if ($[3] !== firstName) {
    t3 = firstName?.charAt(0) ?? "";
    $[3] = firstName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== lastName) {
    t4 = lastName?.charAt(0) ?? "";
    $[5] = lastName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${t3}${t4}`;
  let t6;
  if ($[7] !== t5) {
    t6 = t5.toUpperCase();
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const initials = t6;
  let T0;
  let t7;
  if ($[9] !== className || $[10] !== size) {
    const sizeClasses = {
      sm: "size-12",
      md: "size-16",
      lg: "size-24",
      xl: "size-32"
    };
    T0 = Avatar;
    t7 = cn(sizeClasses[size], className);
    $[9] = className;
    $[10] = size;
    $[11] = T0;
    $[12] = t7;
  } else {
    T0 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== firstName || $[14] !== lastName || $[15] !== photoUrl) {
    t8 = photoUrl && <AvatarImage src={photoUrl} alt={`${firstName} ${lastName}`} />;
    $[13] = firstName;
    $[14] = lastName;
    $[15] = photoUrl;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = initials || "-";
  let t10;
  if ($[17] !== t9) {
    t10 = <AvatarFallback>{t9}</AvatarFallback>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== T0 || $[20] !== t10 || $[21] !== t7 || $[22] !== t8) {
    t11 = <T0 className={t7}>{t8}{t10}</T0>;
    $[19] = T0;
    $[20] = t10;
    $[21] = t7;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};